import { render, staticRenderFns } from "./SalSearch.vue?vue&type=template&id=23359ed4&scoped=true&"
import script from "./SalSearch.vue?vue&type=script&lang=js&"
export * from "./SalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23359ed4",
  null
  
)

export default component.exports